import React from 'react';
import { useSelector } from 'react-redux';

import { TabNames } from '../../../../../../../../../../constants/tabMenuTypes';
import LoadingSpinner from '../../../../../../../../../Spinner';
import TrayHeader from '../../../../../../../../../Tray/TrayHeader';

import CreateCustomLanguageForm from './CreateCustomLanguageForm';

function CreateCustomLanguageTray({ blueprint }) {
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Language));
  const currentEditCustomLanguageId = useSelector(blueprint.selectCurrentEditCustomLanguageId);

  const titles = {
    0: currentEditCustomLanguageId ? 'Edit Custom Language' : 'Create Custom Language',
    2: 'Edit Language Block'
  };

  const renderContent = () => {
    if (activeStep === 0 || activeStep === 2) return <CreateCustomLanguageForm blueprint={blueprint} />;
    return <LoadingSpinner />;
  };

  return (
    <>
      <TrayHeader title={titles[activeStep]} />
      {renderContent()}
    </>
  );
}

export default CreateCustomLanguageTray;
